import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVendorCodesandNames, getVendorBalanceSummaryReportGrid } from '../../api/ReportsAPI/vendorBalanceReportAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchVendorSuggestions = createAsyncThunk('vendorBalanceReport/fetchVendorSuggestions', async (params, { rejectWithValue }) => {
    try { const res = await getVendorCodesandNames(params); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch vendors')); }
});

export const fetchVendorBalanceReport = createAsyncThunk('vendorBalanceReport/fetchReport', async (params, { rejectWithValue }) => {
    try { const res = await getVendorBalanceSummaryReportGrid(params); return res?.Data || null; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch vendor balance report')); }
});

const initialState = {
    suggestions: [], suggestionsLoading: false,
    report: null, reportLoading: false, reportError: null,
};

const vendorBalanceReportSlice = createSlice({
    name: 'vendorBalanceReport',
    initialState,
    reducers: {
        clearVendorSuggestions: (s) => { s.suggestions = []; },
        clearVendorBalanceReport: (s) => { s.report = null; s.reportError = null; },
        resetVendorBalanceReport: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVendorSuggestions.pending, (s) => { s.suggestionsLoading = true; })
            .addCase(fetchVendorSuggestions.fulfilled, (s, a) => { s.suggestionsLoading = false; s.suggestions = a.payload; })
            .addCase(fetchVendorSuggestions.rejected, (s) => { s.suggestionsLoading = false; s.suggestions = []; });

        builder
            .addCase(fetchVendorBalanceReport.pending, (s) => { s.reportLoading = true; s.reportError = null; })
            .addCase(fetchVendorBalanceReport.fulfilled, (s, a) => { s.reportLoading = false; s.report = a.payload; })
            .addCase(fetchVendorBalanceReport.rejected, (s, a) => { s.reportLoading = false; s.reportError = a.payload; });
    },
});

export const { clearVendorSuggestions, clearVendorBalanceReport, resetVendorBalanceReport } = vendorBalanceReportSlice.actions;

export const selectVendorSuggestions        = (s) => s.vendorBalanceReport.suggestions;
export const selectVendorSuggestionsLoading = (s) => s.vendorBalanceReport.suggestionsLoading;
export const selectVendorBalanceReport        = (s) => s.vendorBalanceReport.report;
export const selectVendorBalanceReportLoading = (s) => s.vendorBalanceReport.reportLoading;
export const selectVendorBalanceReportError   = (s) => s.vendorBalanceReport.reportError;

export default vendorBalanceReportSlice.reducer;
